import { jsx as n } from "react/jsx-runtime";
import { A as o, I as i, P as e, C as t, F as r, a as c } from "../../../plans-BhwjptmF.js";
const m = {
  profile: {
    id: "profile",
    text: "Profile",
    onClick: function() {
      throw new Error("Function not implemented.");
    },
    icon: /* @__PURE__ */ n("img", { src: o, className: "b-w-4" })
  },
  incomes: {
    id: "incomes",
    text: "incomes",
    onClick: function() {
      throw new Error("Function not implemented.");
    },
    icon: /* @__PURE__ */ n("img", { src: i, className: "b-w-4" })
  },
  plans: {
    id: "plans",
    text: "plans",
    onClick: function() {
      throw new Error("Function not implemented.");
    },
    icon: /* @__PURE__ */ n("img", { src: e, className: "b-w-4" })
  },
  profiles: {
    id: "profiles",
    text: "profiles",
    onClick: function() {
      throw new Error("Function not implemented.");
    },
    icon: /* @__PURE__ */ n("img", { src: t, className: "b-w-4" })
  },
  favorites: {
    id: "favorites",
    text: "favorites",
    onClick: function() {
      throw new Error("Function not implemented.");
    },
    icon: /* @__PURE__ */ n("img", { src: r, className: "b-w-4" })
  },
  archived: {
    id: "archived",
    text: "archived",
    onClick: function() {
      throw new Error("Function not implemented.");
    },
    icon: /* @__PURE__ */ n("img", { src: c, className: "b-w-4" })
  }
};
export {
  m as HeaderAvatarMenuOptionDefault
};
